import './educationTiles.css'
function EducationTile(props) {
  if ("link" in props.education){
    return (
      <div className='tileWrapper'>
          <a className='verifyLink tooltip' href={props.education.link} target="_blank" rel="noopener noreferrer">
          <span className='tooltipText'>Verify Certificate</span>
          <img src={props.education.image} alt='certification' className='educationImg'/>
            {props.education.title}
          </a>
      </div>
    );
  } else {
    return (
      <div className="tileWrapper">    
        <img src={props.education.image} alt='Certification' className='educationImg'/>
        {props.education.title}
      </div>
    );
  }
}

function EducationTiles(){
  const education = {UB: {title: "B.S. Computer Science", image: "images/UB.png"},
                     CompTiaA: {title: "CompTIA A+ Certificate", image: "images/CompTiaA.svg", link: "https://www.credly.com/badges/09c6ec0f-32e8-4d02-936e-564a5add2c30/public_url"},
                     CompTiaSec: {title: "CompTIA Security+ Certificate", image: "images/CompTiaSec.svg", link: "https://www.credly.com/badges/0c5359d1-17ca-4295-b38c-5cb2d68b34c9/public_url"}
                     }
  return (
    <div className='tileContainer'>
      {Object.keys(education).map((key) => (
        <EducationTile education={education[key]}/>
      ))}
    </div>
  );
}

export default EducationTiles;